import React, {Component} from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from './PrintPreview';
import PdfStore from '../../stores/PdfStore'
import WorkdocStore from '../../stores/WorkdocStore'
import FontAwesome from 'react-fontawesome';
import LazyLoad from 'react-lazyload';
import ProgressiveImage from 'react-progressive-image'
import BookPartItemTable from '../book/BookPartItemTable'
import Waypoint from 'react-waypoint'

var NotificationSystem = require('react-notification-system');
const RELATED_DOC = {checkedIndex:[],subCheckedIndex:[]}
class PrintKKCPhotobook extends Component {

  constructor(...args){
    super(...args)
    this.state = {
      loading:false,
      data:{files:[]},
      page:{files:[{createddate:'',deleteType:'',deleteUrl:'',deleteWithCredentials:'',height:'',name:'',size:'',thumbnailUrl:'',url:'',width:''}]},
      is_index:[],
      related_doc:RELATED_DOC,
      dataTable:[],
      isPage:0
    }

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem
  	this.loadData()
  }

  loadData() {
  	this.setState({loading:true})
    PdfStore.loadPhotoBook((result)=>{
      this.setState({loading:false,data:result.data})
      if(this.props.workNo!==undefined || this.props.workNo!=='')
        this.loadWorkdocRelated()
    })
  }

  loadPhotoBookContent(_page=0) {
    let {dataTable,related_doc} = this.state
    this.setState({isPage:_page,loading:true})
    
    if (related_doc.checkedIndex.length>0)
      _page = related_doc.checkedIndex[_page]

    PdfStore.loadPhotoBookContent(parseInt(_page)+1,(result)=>{
      this.setState({dataTable:result.data,loading:false})
    })
  }

  loadWorkdocRelated() {
    let {related_doc,page,data,is_index,isPage} = this.state
    this.setState({loading:true})
    WorkdocStore.loadWorkdocRelated(this.props.workNo,'kkc_photobook_doc',(result)=>{
      if (result.data.checkedIndex===undefined||result.data.subCheckedIndex===undefined)
        related_doc = RELATED_DOC
      else 
        related_doc = result.data
      
      if(related_doc.subCheckedIndex===undefined){
        related_doc.subCheckedIndex = []
      }

      let _page = {files:[]}
      let is_checked = false
      related_doc.checkedIndex.forEach(function(item,index) {
        is_checked = true
        _page.files.push({createddate:data.files[item].createddate,deleteType:data.files[item].deleteType,deleteUrl:data.files[item].deleteUrl,deleteWithCredentials:data.files[item].deleteWithCredentials,height:data.files[item].height,name:data.files[item].name,size:data.files[item].size,thumbnailUrl:data.files[item].thumbnailUrl,url:data.files[item].url,width:data.files[item].width})
        let cur_index = data.files.findIndex(x => x.name===data.files[item].name)
        is_index.push(cur_index)
      })

      if (is_checked)
        page = _page

      this.setState({loading:false,related_doc:related_doc,page:page,is_index:is_index})
      this.loadPhotoBookContent(isPage)
    })
  }

  newEmptyRealPage(number){
    return new Array(number).fill(null).map((item,index)=>{
      return {key:false,value:false}
    })
  } 

  onSideBarSelect(_return) {
  	let {related_doc,page,data,is_index,isPage} = this.state
    if (is_index.indexOf(_return.index)===-1) {
      related_doc.checkedIndex.push(_return.index)
      related_doc.subCheckedIndex.push({pageKey:_return.index,pageIndex:[]})
      is_index.push(_return.index)
    } else {
      let key = is_index.indexOf(_return.index)
      related_doc.checkedIndex.splice(key,1)
      related_doc.subCheckedIndex.splice(key,1)
      is_index.splice(key,1)
    }

    is_index = is_index.sort(function(a, b){return a-b})
    related_doc.checkedIndex = related_doc.checkedIndex.sort(function(a, b){return a-b})
    related_doc.subCheckedIndex = related_doc.subCheckedIndex.sort(function(a, b) {
      if(a.pageKey < b.pageKey) return -1;
      if(a.pageKey > b.pageKey) return 1;
      return 0;
    })

    page = {files:[]}
    is_index.forEach(function(key,index) {
      page.files.push(data.files[key])
    })
  	
  	if (page.files.length===0||page.files.undefined) {
  		page = {files:[{createddate:'',deleteType:'',deleteUrl:'',deleteWithCredentials:'',height:'',name:'',size:'',thumbnailUrl:'',url:'',width:''}]}
    }
    
  	this.setState({page:page,is_index:is_index,related_doc:related_doc})
    this.saveWorkdocRelated()

    let _page = isPage
    if (isPage>related_doc.subCheckedIndex.length-1)
      _page = related_doc.subCheckedIndex.length-1

    if (_page<0)
      _page = 0

    this.loadPhotoBookContent(_page)
  }

  onPartClick(_checked) {
    let {related_doc} = this.state
    if (_checked.val===-1) {
      related_doc.subCheckedIndex[_checked.page].pageIndex.push(_checked.index)
    } else {
      let key = related_doc.subCheckedIndex[_checked.page].pageIndex.indexOf(_checked.index)
      related_doc.subCheckedIndex[_checked.page].pageIndex.splice(key,1)
    }
    this.setState({related_doc:related_doc})
    this.saveWorkdocRelated()
  }

  saveWorkdocRelated() {
    let {related_doc} = this.state
    let {workNo} = this.props

    if(workNo===undefined || workNo===''){
      return;
    }

    WorkdocStore.saveWorkdocRelated(workNo,'kkc_photobook_doc',related_doc,(result) => {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดเอกสารประกอบเลขงานซ่อม ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      })
    },(result) => {
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึกเอกสารประกอบเลขงานซ่อม ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      })
    })
  }

  renderComponentPage(items,indexs,length) {
    let {data,related_doc} = this.state

  	return(
  		<div className={'font-print text-center kkc-img'} key={indexs}>
        <ProgressiveImage src={items.url} placeholder={items.thumbnailUrl}>
          {(src) => <img src={src} width={'92%'} />}
        </ProgressiveImage> 
        <div className='footer-page text-right' style={{display:(related_doc.checkedIndex.length===0?'none':'')}}>
          <small style={{fontSize:'20px'}}>{related_doc.checkedIndex[indexs]+1}</small>
        </div>
        {this._renderWaypoint(indexs)}
  		</div>
  	)
  }

  renderSideBarRight(dataTable,related_doc,isPage) {
    return(
      <td className="sub-sliptable-box" style={{width:'21%'}}>
        <div style={{marginTop:'150px',marginRight:'auto',overflowY:'auto',height:'29.7cm',width:'15cm'}}>
          <div className='x-table' style={{overflowX:'auto'}}>
            <BookPartItemTable
              pageNo={1} 
              bookId={'hino'}
              selectColumn={['0','1','2','3']}
              data={dataTable}
              checked={related_doc.subCheckedIndex}
              isPage={isPage}
              onPartClick={this.onPartClick.bind(this)}
            >
            </BookPartItemTable>
          </div>  
        </div>
      </td>
    )
  }

  _loadMoreItems(page,e) {
    this.loadPhotoBookContent(page)
  }

  _renderWaypoint(page='') {
    return(
      <Waypoint
        onEnter={this._loadMoreItems.bind(this,page)}
      />
    )
  }

  render() {
    let {loading,page,is_index,dataTable,isPage,related_doc} = this.state
    
    return(
      <div>
        <PrintPreview 
        	size={'portrait'}
          loading={loading}
          leftBarTitle={this.props.title}
          sideBar={true}
          sideBarData={this.state.data}
          sideBarRelated={this.state.related_doc}
          onSideBarSelect={this.onSideBarSelect.bind(this)}
          renderSideBarRight={this.renderSideBarRight.bind(this,dataTable,related_doc,isPage)}
        >
          {
          	page.files.map((item,index)=> {
          		return(
          			this.renderComponentPage(item,index,this.state.page.files.length)
          		)
          	})
          }
        </PrintPreview>
        <NotificationSystem ref="notificationSystem" />
      </div>  
    )
  }
}  

PrintKKCPhotobook.defaultProps = {
  title: 'Photobook',
}
export default PrintKKCPhotobook;


// WEBPACK FOOTER //
// ./src/view/print/PrintKKCPhotobook.js